export class SaleOfferBearingVisibility {
  constructor(
    public saleOfferBearingHash?: string,
    public saleOfferLineHash?: string
  ) { }

  clone() {
    return new SaleOfferBearingVisibility(
      this.saleOfferBearingHash,
      this.saleOfferLineHash
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer-bearing-visibility.ts